<router-outlet></router-outlet>
<ngx-spinner type="ball-scale-multiple" role="status" aria-live="polite">
    <span class="normal-theme" [attr.aria-label]="'loading.spinner.load.aria' | translate"></span>
    <span class="no-spinner-theme" translate>loading.spinner.load</span>
</ngx-spinner>
<div kendoDialogContainer></div>

<div id="components-reconnect-modal" class="my-reconnect-modal components-reconnect-hide" *ngIf="blazorLibIsLoaded()">
    <div class="show">
        <div class="content-wrapper">
            <p translate>
                anfragelivesharing.error.trying
                <br>
                <span id="components-reconnect-current-attempt"></span> /
                <span id="components-reconnect-max-retries" translate></span> anfragelivesharing.error.versuch
            </p>
        </div>
    </div>
    <div class="failed">
        <div class="content-wrapper">
            <p translate>
                anfragelivesharing.error.max
                <br>
                <button kendoButton (click)="reconnectBlazor()">
                    <span translate>anfragelivesharing.error.reconnect</span>
                </button>
                <br><br>
                anfragelivesharing.error.maxsave
                <br>
                <button kendoButton (click)="closeBlazorDisconnectScreen()">
                    <span translate>confirmationDialog.confirm</span>
                </button>
            </p>
        </div>
    </div>
    <div class="rejected">
        <div class="content-wrapper">
            <p translate>
                anfragelivesharing.error.save
                <br>
                <button kendoButton (click)="closeBlazorDisconnectScreen()" translate>
                    <span translate>confirmationDialog.confirm</span>
                </button>
            </p>
        </div>
    </div>
</div>